import { motion } from "framer-motion"
import { Observer, observer } from "mobx-react-lite"
import { useState } from "react"
import { Prompts } from "../models/api/Prompts"
import { ProfPrompt } from "../models/app/ProfPrompt"
import Logger from "../services/Logger"
import { ProfileStore } from "../stores/ProfileStore"

const PromptCont = observer((props: { prompt: ProfPrompt, defQ: string }) => {

    const [isOpen, setIsOpen] = useState(false)

    const prompt = props.prompt
    const q = prompt.q
    const a = prompt.a
    return (
        <motion.div className='flex-column prompt-cont '
            layout
            data-isOpen={isOpen}
        >
            <div onClick={() => setIsOpen(!isOpen)} >
                <input className='input-prompt-q' type="text" placeholder='Your question'
                    value={prompt.q ?? props.defQ} onChange={e => { prompt.q = e.target.value }} />
            </div>
            <div className='prompt-ans-wrapper' style={{ position: 'relative' }}>
                <textarea className='prompt-ans-text' name=""
                    placeholder='Your answer'
                    maxLength={100}
                    value={prompt.a}
                    onChange={(e) => { prompt.a = e.target.value }}  ></textarea>
                <p style={{ position: 'absolute', right: 10, bottom: 10 }} >{prompt.a.length}/100</p>
            </div>

        </motion.div>
    )
})

const EditPrompts = (props: { store: ProfileStore }) => {

    const prompts = props.store.prompts
    if (prompts.length < 3)
        return null

    return (
        <div className='flex-column' style={{ width: '80%' }} >
            <h3>Prompts</h3>
            <PromptCont key={0} defQ='My fav food' prompt={prompts[0]} />
            <PromptCont key={1} defQ='My fav food' prompt={prompts[1]} />
            <PromptCont key={2} defQ='My fav food' prompt={prompts[2]} />

        </div>
    )

}

export default observer(EditPrompts)